import { Component, Inject, Injector, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import {
  FormComponent,
  IFormDialogData,
} from "src/app/shared/form/form.component";

export interface IDeleteDialogData extends IFormDialogData {
  service: any;
  title: string;
  customDelete?: () => Observable<any>;
  confirmationMessage?: string;
}

@Component({
  standalone: false,
  selector: "app-delete-dialog",
  templateUrl: "./delete-dialog.component.html",
  styleUrl: "./delete-dialog.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None
})
export class DeleteDialog extends FormComponent<any> implements OnInit {
  confirmationMessage: string;

  constructor(
    dialogRef: MatDialogRef<DeleteDialog>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: IDeleteDialogData,
    protected injector: Injector,
  ) {
    super(dialogRef, data.service, data, data.title, injector);
    this.confirmationMessage = data.confirmationMessage ?? this.translateService.getDynamicTranslation(
      'Are you sure you want to delete this {{title}}? This action cannot be undone',
      { title: this.translateService.getDynamicTranslation(data.title) }
    );
    this.formDeletes = true;
  }

  ngOnInit() { }

  delete() {
    if (!this.data.customDelete) {
      super.delete();
    } else {
      this.isLoading = true;
      this.data.customDelete().pipe(
        finalize(() => (this.isLoading = false))
      ).subscribe({
        next: () => {
          this.toastService.showSuccess(
            this.translateService.getDynamicTranslation(
              '{{title}} deleted successfully',
              { title: this.translateService.getDynamicTranslation(this.data.title) }
            ),
            true
          );
          this.dialogRef.close(true);
        },
        error: this.handleError
      });
    }
  }

  getNewObject(): any {
    return;
  }

  validate(): boolean {
    return true;
  }
}
